import React, {PureComponent} from 'react';
import $ from "jquery";
import {formatTime, calculateAVGSpeed} from '../functions/utils';
import ReactTooltip from 'react-tooltip';
import Alert from 'react-s-alert';
import Toggle from "react-bootstrap-toggle";
import logo from "../../img/logo_small.png";
import {Modal} from 'react-responsive-modal';
import PortraitModal from "../independentComponents/portraitModalComponent";
import Moment from "moment-timezone";
import waterfall from "async/waterfall";
import parallel from "async/parallel";

import {
    subscribeToLapInfo,
    subscribeCarToServer,
    subscribeDashToServer,
    connectSocket,
    closeSocket
} from "../functions/api";

import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

const telemetryIP = process.env.REACT_APP_TELEMETRY_IP;
const messagePort = process.env.REACT_APP_MESSAGE_PORT;

const super_admin = parseInt(process.env.REACT_APP_SUPER_ADMIN_ID);
const admin = parseInt(process.env.REACT_APP_EVENT_ADMIN_ID);
const sub_admin = parseInt(process.env.REACT_APP_EVENT_SUB_ADMIN_ID);

class PopoutLapTimes extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            sectors: [],
            laps: [],
            tableRows: [],
            maxes: {
                personal: {min_time: 0, max_speed_obd: 0, max_speed_gps: 0, max_g_x: 0, min_g_x: 0, max_g_y: 0, min_g_y: 0, lap_number: 0, registry_timestamp: 0},
                overall: {min_time: 0, max_speed_obd: 0, max_speed_gps: 0, max_g_x: 0, min_g_x: 0, max_g_y: 0, min_g_y: 0, lap_number: 0, registry_timestamp: 0}
            },
            overallBestColor: "#980092",
            personalBestColor: "#019100",
            selectedLaps: [],
            selectedLapsHaveBulk: [],
            sessionID: this.props.match ? this.props.match.params.sessionID : this.props.sessionID,
            eventID: this.props.match ? this.props.match.params.eventID : this.props.eventID,
            carID: this.props.match ? this.props.match.params.carID : this.props.carID,
            privileges: this.props.privileges ? this.props.privileges : [],
            heightCompensation: 40,
            partials: {
                single: {
                    S1: {time: 0, driver: "---", team: "---", number: 0, lap: 0, stamp: 0},
                    S2: {time: 0, driver: "---", team: "---", number: 0, lap: 0, stamp: 0},
                    S3: {time: 0, driver: "---", team: "---", number: 0, lap: 0, stamp: 0},
                },
                overall: {
                    S1: {time: 0, driver: "---", team: "---", number: 0, lap: 0, stamp: 0},
                    S2: {time: 0, driver: "---", team: "---", number: 0, lap: 0, stamp: 0},
                    S3: {time: 0, driver: "---", team: "---", number: 0, lap: 0, stamp: 0},
                }
            },
            sectorView: false,
            sectorViewActive: false,
            splitHeaders: [],
            show: false,
            lapToUpdateStatus: null,
            lapState: "",
            isMobile: false,
            csvModalShow: false,
            CSVmodalRows: [],
            CSVmodalIndexes: [],
            isOwnTeam: 0,
            pageSize: 20,
            firstRecord: 0,
            circuitLength: this.props.match ? null : this.props.circuitLength,
            circuitTimezone: this.props.match ? null : this.props.circuitTimezone,
            startTimestamp: this.props.match ? null : this.props.startTimestamp,
            lastReset: this.props.match ? null : this.props.lastReset,
        };

        this.getSessionDetails = this.getSessionDetails.bind(this);
        this.getCarLaps = this.getCarLaps.bind(this);
        this.popoutDetail = this.popoutDetail.bind(this);
        this.popoutComparison = this.popoutComparison.bind(this);
        this.getCircuitDetails = this.getCircuitDetails.bind(this);
        this.getMaxes = this.getMaxes.bind(this);
        this.makeTableRows = this.makeTableRows.bind(this);
        this.makeSplits = this.makeSplits.bind(this);
        this.makePersonalTheoreticalBestLapRow = this.makePersonalTheoreticalBestLapRow.bind(this);
        this.makeOverallTheoreticalBestPartialsRow = this.makeOverallTheoreticalBestPartialsRow.bind(this);
        this.handleSelectLap = this.handleSelectLap.bind(this);
        this.startupPage = this.startupPage.bind(this);
        this.getComposedSectors = this.getComposedSectors.bind(this);
        this.makeSectorsContainer = this.makeSectorsContainer.bind(this);
        this.onToggleSectorView = this.onToggleSectorView.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleConfirmAction = this.handleConfirmAction.bind(this);
        this.makeEXCEL = this.makeEXCEL.bind(this);
        this.checkMobile = this.checkMobile.bind(this);
        this.updateLapState = this.updateLapState.bind(this);
        this.updateLapStateCommand = this.updateLapStateCommand.bind(this);
        this.handleCGenerateCSV = this.handleCGenerateCSV.bind(this);
        this.handleOpenModalCSV = this.handleOpenModalCSV.bind(this);
        this.handleCloseModalCSV = this.handleCloseModalCSV.bind(this);
        this.makeCSVmodalRows = this.makeCSVmodalRows.bind(this);
        this.getUserPrivileges = this.getUserPrivileges.bind(this);
        this.handleClickPager = this.handleClickPager.bind(this);

        this.masterGetter = this.masterGetter.bind(this);
        this.masterRenderer = this.masterRenderer.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {
        const helper = this;
        parallel([
            function (p_callback) {
                helper.checkMobile();
                p_callback(null, "ok");
            },
            function (p_callback) {
                helper.getCircuitDetails((status) => {
                    p_callback(null, status);
                });
            },
            function (p_callback) {
                helper.getSessionDetails((status) => {
                    p_callback(null, status);
                });
            },
        ], function (err, results) {
            console.log("[LAP TIMES] COMPLETED fetch static data");
        });

        if (this.props.match) {
            this.startupPage();
        }
        if (this.props.match || this.props.isActive === 1) {
            if (this.props.isActive === 1) {
                this.setState({
                    heightCompensation: 200,
                });
            } else {
                this.setState({
                    heightCompensation: 30,
                });
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.isActive !== this.props.isActive || (this.props.carID && prevProps.carID !== this.props.carID)) {
            if (this.props.isActive === 1) {
                this.setState({
                    carID: this.props.carID,
                    isOwnTeam: this.props.isOwnTeam,
                }, () => {
                    if (this.props.isOwnTeam === 1 || (this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin))) {
                        this.startupPage();
                        if (this.props.isActive === 1) {
                            this.setState({
                                heightCompensation: 200,
                            });
                        } else {
                            this.setState({
                                heightCompensation: 30,
                            });
                        }
                    } else {
                        Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal;">' + this.props.t("notAuthorizedLaps") + '!</span>', {
                            position: 'top-right',
                            effect: 'genie',
                            beep: true,
                            timeout: 20000,
                            offset: 150
                        });
                    }
                });
            }
        }
    }

    componentWillUnmount() {
        // Notify server of new connection
        subscribeCarToServer(this.state.eventID, null, () => {
            subscribeToLapInfo(this.state.carID, null, true, null);
        });
        if (this.props.match) {
            closeSocket();
        }
    }

    /* GET DATA */
    masterGetter(callback) {
        const helper = this;
        parallel([
            function (p_callback) {
                helper.getMaxes((status) => {
                    p_callback(null, status);
                });
            },
            function (p_callback) {
                helper.getCarLaps((status) => {
                    p_callback(null, status);
                });
            },
            function (p_callback) {
                helper.getComposedSectors((status) => {
                    p_callback(null, status);
                });
            }
        ], function (err, results) {
            if (callback) {
                callback("done");
            }
        });
    }

    masterRenderer(callback) {
        const helper = this;
        waterfall([
            function (w_callback) {
                helper.makePersonalTheoreticalBestLapRow((status) => {
                    w_callback(null);
                });
            },
            function (w_callback) {
                helper.makeOverallTheoreticalBestPartialsRow((status) => {
                    w_callback(null);
                });
            },
            function (w_callback) {
                helper.makeSectorsContainer((status) => {
                    w_callback(null);
                });
            },
            function (w_callback) {
                helper.makeTableRows((status) => {
                    w_callback(null);
                });
            }
        ], function (err, results) {
            console.log("[LAP TIMES] RENDERING DONE");
            if (callback) {
                callback("done");
            }
        });
    }

    startupPage() {
        console.log("[LAP TIMES] Loading up components");
        if (this.state.carID !== null) {
            $(".loading").fadeIn();
            this.setState({
                firstRecord: 0,
            });
        }

        // Disable paging buttons, enable as necessary
        $('#previous').prop("disabled", true);
        $('#next').prop("disabled", true);

        this.masterGetter(() => {
            $(".loading").fadeOut();
            if (this.props.match) {
                this.getUserPrivileges((status) => {
                    this.masterRenderer(() => {
                        console.log("[LAP TIMES] THIS IS AN INDEPENDENT WINDOW");
                        // Connect socket
                        connectSocket(this.props.cookies.get("authToken"), this.state.carID, this.state.sessionID, this.state.eventID, "LAPTIMES", (msg) => {
                            console.log("[LAP TIMES]" + msg);

                            subscribeDashToServer(this.state.eventID, this.state.sessionID, () => {
                                console.log("[LAP TIMES] DEDICATED STREAM SUBSCRIBED");
                            });
                            subscribeCarToServer(this.state.eventID, this.state.carID, (err, pack) => {
                                console.log("[LAP TIMES] CAR ", pack.carId, " SUBSCRIBED EVENT", pack.eventId);
                            });
                            subscribeToLapInfo(this.state.carID, this.state.carID, false, () => {
                                this.masterGetter(() => {
                                    this.masterRenderer(null);
                                });
                            });
                        });
                    });
                });
            } else {
                this.masterRenderer(() => {
                    console.log("[LAP TIMES] THIS IS A COMPONENT");
                    // Notify server of new connection
                    subscribeCarToServer(this.state.eventID, this.state.carID, (err, pack) => {
                        console.log("[LAP TIMES] CAR ", pack.carId, " SUBSCRIBED EVENT", pack.eventId);
                    });
                    subscribeToLapInfo(this.state.carID, this.state.carID, false, () => {
                        this.masterGetter(() => {
                            this.masterRenderer(null);
                        });
                    });
                });
            }
        });
    }

    getUserPrivileges(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getUserPrivileges',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                carID: helper.state.carID,
            },
            success: function (data) {
                helper.setState({
                    privileges: data["privileges"],
                    isOwnTeam: data["isOwnTeam"]
                }, () => {
                    callback("ok");
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    getSessionDetails(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getSessionDetails',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.state.sessionID,
            },
            success: function (data) {
                helper.setState({
                    circuitLength: data.track_length,
                    circuitTimezone: data.timezone,
                    startTimestamp: data.start_timestamp,
                    lastReset: data.last_reset,
                }, () => {
                    console.log("[LAP TIMES] COMPLETE getSessionDetails");
                    callback("ok");
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    getCircuitDetails(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getSectorInfo',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.state.sessionID
            },
            success: function (data) {
                helper.setState({
                    sectors: data,
                }, () => {
                    console.log("[LAP TIMES] COMPLETE getCircuitDetails");
                    callback("ok");
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    getMaxes(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getMaxes',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.state.sessionID,
                carID: helper.state.carID,
            },
            success: function (data) {
                if (data && data.length > 0) {
                    helper.setState({
                        maxes: data[0],
                    }, () => {
                        console.log("[LAP TIMES] COMPLETE getMaxes");
                        callback("ok");
                    });
                } else {
                    callback("nok");
                }
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    getCarLaps(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getLapsByCarID',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.state.sessionID,
                carID: helper.state.carID,
            },
            success: function (data) {
                helper.setState({
                    laps: data,
                }, () => {
                    console.log("[LAP TIMES] COMPLETE getCarLaps");
                    callback("ok");
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    getComposedSectors(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getComposedSectorTimes',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.state.sessionID,
                carID: helper.state.carID,
            },
            success: function (data) {
                helper.setState({
                    partials: data,
                }, () => {
                    helper.setState({
                        sectorViewActive: true,
                    }, () => {
                        console.log("[LAP TIMES] COMPLETE getComponsedSectors");
                        callback("ok");
                    });
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    /* HANDLERS */
    handleSelectLap(e, uuid, bulkData) {
        e.preventDefault();
        e.stopPropagation();
        if (!$(e.target).hasClass("excludeClick")) {
            if (!this.state.selectedLaps.includes(uuid) && this.state.selectedLaps.length >= 2) {
                Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px; white-space: normal;">' + this.props.t("select2LapsOnly") + '!</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: false,
                    timeout: 2500,
                    offset: 150
                });
            } else {
                // If already was in array, remove it
                if (this.state.selectedLaps.includes(uuid)) {
                    for (let i = 0; i < this.state.selectedLaps.length; i++) {
                        if (this.state.selectedLaps[i] === uuid) {
                            let temp1 = this.state.selectedLaps.slice();
                            let temp2 = this.state.selectedLapsHaveBulk.slice();
                            temp1.splice(i, 1);
                            temp2.splice(i, 1);
                            this.setState({
                                selectedLaps: temp1,
                                selectedLapsHaveBulk: temp2
                            });
                        }
                    }
                    $('#' + uuid).prop("checked", false);
                } else {
                    // Not in array, add it, if bulkdata is the same
                    if (this.state.selectedLapsHaveBulk.length > 0) {
                        if (bulkData !== this.state.selectedLapsHaveBulk[0]) {
                            Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px; white-space: normal;">' + this.props.t("lapsMustHaveSameData") + '!</span>', {
                                position: 'top-right',
                                effect: 'genie',
                                beep: false,
                                timeout: 5000,
                                offset: 150
                            });
                            return false;
                        }
                    }

                    let temp1 = this.state.selectedLaps.slice();
                    let temp2 = this.state.selectedLapsHaveBulk.slice();
                    temp1.push(uuid);
                    temp2.push(bulkData);
                    this.setState({
                        selectedLaps: temp1,
                        selectedLapsHaveBulk: temp2
                    });
                    $('#' + uuid).prop("checked", true);
                }
            }
        }
    }

    onToggleSectorView() {
        this.setState({
            sectorView: !this.state.sectorView,
        }, () => {
            this.makeTableRows(null);
        });
    }

    handleShowModal(e) {
        e.preventDefault();
        e.stopPropagation();
        let parts = e.target.value.split("_");
        this.setState({
            show: true,
            lapToUpdateStatus: e.target.value,
            lapState: parseInt(parts[1]) === 1 ? this.props.t("valid") : this.props.t("invalid"),
        });
    }

    handleCloseModal() {
        this.setState({
            show: false,
            serverResult: <div/>
        });
    }

    handleConfirmAction(e) {
        let parts = this.state.lapToUpdateStatus.split("_");
        console.log("[LAP TIMES] Lap", this.state.lapToUpdateStatus, "was marked with", parseInt(parts[1]) === 1 ? 0 : 1);
        this.updateLapState(parts[0], parseInt(parts[1]) === 1 ? 0 : 1);
    }

    updateLapState(lap, newStatus) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/updateLapStatus',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                lapUUID: lap,
                newStatus: newStatus,
            },
            success: function (data) {
                helper.updateLapStateCommand();
                Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px; white-space: normal;">' + helper.props.t("latStatusUpdated") + '!</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: false,
                    timeout: 2500,
                    offset: 150
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                    Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px; white-space: normal;">' + helper.props.t("somethingWentWrong") + '!</span>', {
                        position: 'top-right',
                        effect: 'genie',
                        beep: false,
                        timeout: 2500,
                        offset: 150
                    });
                }
            }
        }).done(function () {
            console.log("[LAP TIMES] COMPLETE updateLapStatus");
            let parts = helper.state.lapToUpdateStatus.split("_");
            for (let i = 0; i < helper.state.laps.length; i++) {
                if (parts[0] === helper.state.laps[i].uuid) {
                    helper.state.laps[i].is_valid = parseInt(parts[1]) === 1 ? 0 : 1;
                }
            }
            helper.makeTableRows(null);
            helper.handleCloseModal();
        });
    }

    updateLapStateCommand() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: telemetryIP + ':' + messagePort + '/session-car-best-lap-adjust?carId=' + helper.state.carID + '&sessionId=' + helper.state.sessionID,
            headers: {
                'Authorization': 'Basic ' + btoa('admin:vZ3s4T7MJfWhHD5H')
            },
            dataType: 'json',
            success: function () {
                console.log('[ORGANIZER LAP TIMES] Successfully adjusted BEST LAP TIME.');
                helper.getMaxes();
            }, error: function (err) {
                if (err)
                    console.error('Error adjusting BEST LAP TIME.');
            }
        });
    }

    handleCGenerateCSV(e) {
        e.preventDefault();
        $("#btnGenerateCSV").attr("disabled", true).text(this.props.t("pleaseWait") + " ...");
        if (this.state.CSVmodalIndexes.length > 0) {
            let start = this.state.laps[this.state.CSVmodalIndexes[this.state.CSVmodalIndexes.length - 1]];
            let end = this.state.laps[this.state.CSVmodalIndexes[0]];
            const helper = this;
            $.ajax({
                type: 'POST',
                url: serverIP + ':' + backendPort + '/dashboard/getCSVdata',
                headers: {
                    'authorization': helper.props.cookies.get("authToken")
                },
                data: {
                    sessionID: helper.state.sessionID,
                    carID: helper.state.carID,
                    start: (start.registry_timestamp - start.time),
                    end: (helper.state.CSVmodalIndexes.length > 1 ? end.registry_timestamp : start.registry_timestamp),
                },
                success: function (data) {
                    const element = document.createElement("a");
                    const file = new Blob([data], {type: 'text/plain'});
                    element.href = URL.createObjectURL(file);
                    element.download = "chronolive_telemetry.csv";
                    document.body.appendChild(element); // Required for this to work in FireFox
                    element.click();
                    helper.handleCloseModalCSV();
                },
                error: function (err) {
                    if (err) {
                        console.error('Error:', err);
                    }
                    return false;
                }
            });
        }
    }

    handleOpenModalCSV(e) {
        e.preventDefault();
        if (this.state.selectedLaps.length < 1) {
            Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("atLeast1Lap") + '!</span>', {
                position: 'top-right',
                effect: 'genie',
                beep: false,
                timeout: 5000,
                offset: 150
            });
        } else {
            this.setState({
                csvModalShow: true,
            }, () => {
                setTimeout(() => {
                    this.makeCSVmodalRows();
                }, 300);
            });
        }
    }

    handleCloseModalCSV() {
        this.setState({
            csvModalShow: false,
        });
    }

    handleClickPager(e) {
        e.preventDefault();

        let tmpRec = this.state.firstRecord;
        let pageSize = this.state.pageSize;

        // Define the new first record
        if (["start", "end"].includes(e.target.id)) {
            if (e.target.id === 'start') {
                tmpRec = 0;
            } else {
                tmpRec = this.state.laps.length - (this.state.laps.length % 20);
            }
        } else {
            if (e.target.id === "next") {
                tmpRec += pageSize;
            } else {
                tmpRec -= pageSize;
            }
        }
        // The first record is < of 0 or > of total rows
        if (tmpRec < 0 || tmpRec > this.state.laps.length) {
            return;
        }

        // Update the current record
        this.setState({
            firstRecord: tmpRec,
        }, () => {

            if (this.state.firstRecord === 0) {
                $('#previous').prop("disabled", true);
            } else {
                $('#previous').prop("disabled", false);
            }

            if ((this.state.firstRecord + this.state.pageSize) >= this.state.laps.length) {
                $('#next').prop("disabled", true);
            } else {
                $('#next').prop("disabled", false);
            }

            this.makeTableRows();
        });
    }

    /* POPOUTS */
    popoutComparison(e) {
        if (this.state.selectedLaps.length < 2) {
            e.preventDefault();
            Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("2LapsToCompare") + '!</span>', {
                position: 'top-right',
                effect: 'genie',
                beep: false,
                timeout: 5000,
                offset: 150
            });
        } else {
            let uuidList = "";
            for (let i = 0; i < this.state.selectedLaps.length; i++) {
                uuidList += this.state.selectedLaps[i] + "_";
            }
            window.open(
                "/lapComparison/" + this.state.eventID + "/" + this.state.sessionID + "/" + uuidList.substring(0, uuidList.length - 1),
                'lapComparison',
                "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=100,top=100,height=750,width=900"
            );
        }
    }

    popoutDetail(e) {
        e.stopPropagation();
        e.preventDefault();
        window.open(
            "/lapDetails/" + this.state.eventID + "/" + this.state.sessionID + "/" + e.target.value,
            'lapDetail',
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=100,top=100,height=750,width=900"
        );
    }

    /* PDF EXPORT */
    checkMobile() {
        let check = false;
        (function (a) {
            //eslint-disable-next-line
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        this.setState({
            isMobile: check,
        });
    }

    makeEXCEL(e) {
        $(".loading").fadeIn();
        e.stopPropagation();
        e.preventDefault();
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getLapsExcel',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.state.sessionID,
                carID: helper.state.carID,
                sectorView: helper.state.sectorView,
                timezone: helper.state.circuitTimezone,
                trackLength: helper.state.circuitLength,
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (data) {
                const element = document.createElement("a");
                const file = new Blob([data], {type: 'text/plain'});
                element.href = URL.createObjectURL(file);
                element.download = "chronolive_laptimes.xlsx";
                document.body.appendChild(element); // Required for this to work in FireFox
                element.click();
            },
            error: function (err, a, b) {
                if (err) {
                    console.error(a, 'Error:', b);
                }
            }
        }).done(() => {
            $(".loading").fadeOut();
        });
    }

    /* RENDER */
    makeSectorsContainer(callback) {
        let containerOverall = (
            <tr className={"App_white_text"}>
                <td style={{fontSize: 17, background: this.state.overallBestColor}} colSpan={2}>
                    {this.props.t("overallBestSectors")}
                </td>
                <td>
                    <b>{formatTime(this.state.partials.overall.S1.time + this.state.partials.overall.S2.time + this.state.partials.overall.S3.time)}</b>
                </td>
                <td className={"hidden-xs"}
                    colSpan={3}
                    style={{fontWeight: "bold", borderLeft: "2px solid white", borderRight: "2px solid white"}}
                    data-tip={true}
                    data-for={"S1_overall"}
                >
                    <div style={{cursor: "pointer"}}>
                        {this.state.partials.overall.S1.time > 0 ?
                            (((this.state.partials.overall.S1.time / 1000) * 1000) / 1000).toFixed(3) : "---"
                        }
                        <ReactTooltip id={"S1_overall"} type={"light"}>
                            <span className={"App_title"}>{this.state.partials.overall.S1.driver.toUpperCase()}</span>
                            <span style={{fontSize: 22}}>#{this.state.partials.overall.S1.number} {this.state.partials.overall.S1.team}</span>
                            <span className={"App_title"}>{this.props.t("lap") + " " + this.state.partials.overall.S1.lap}</span>
                            <span style={{fontSize: 22}}>{Moment(this.state.partials.overall.S1.stamp).tz(this.state.circuitTimezone).format("HH:mm:ss")}</span>
                        </ReactTooltip>
                    </div>
                </td>
                <td className={"hidden-xs"}
                    colSpan={3}
                    style={{fontWeight: "bold", borderLeft: "2px solid white", borderRight: "2px solid white"}}
                    data-tip={true}
                    data-for={"S2_overall"}
                >
                    <div style={{cursor: "pointer"}}>
                        {this.state.partials.overall.S2.time > 0 ?
                            (((this.state.partials.overall.S2.time / 1000) * 1000) / 1000).toFixed(3) : "---"
                        }
                        <ReactTooltip id={"S2_overall"} type={"light"}>
                            <span className={"App_title"}>{this.state.partials.overall.S2.driver.toUpperCase()}</span>
                            <span style={{fontSize: 22}}>#{this.state.partials.overall.S2.number} {this.state.partials.overall.S2.team}</span>
                            <span className={"App_title"}>{this.props.t("lap") + " " + this.state.partials.overall.S2.lap}</span>
                            <span style={{fontSize: 22}}>{Moment(this.state.partials.overall.S2.stamp).tz(this.state.circuitTimezone).format("HH:mm:ss")}</span>
                        </ReactTooltip>
                    </div>
                </td>
                <td className={"hidden-xs"}
                    colSpan={4}
                    style={{fontWeight: "bold", borderLeft: "2px solid white", borderRight: "2px solid white"}}
                    data-tip={true}
                    data-for={"S3_overall"}
                >
                    <div style={{cursor: "pointer"}}>
                        {this.state.partials.overall.S3.time > 0 ?
                            (((this.state.partials.overall.S3.time / 1000) * 1000) / 1000).toFixed(3) : "---"
                        }
                        <ReactTooltip id={"S3_overall"} type={"light"}>
                            <span className={"App_title"}>{this.state.partials.overall.S3.driver.toUpperCase()}</span>
                            <span style={{fontSize: 22}}>#{this.state.partials.overall.S3.number} {this.state.partials.overall.S3.team}</span>
                            <span className={"App_title"}>{this.props.t("lap") + " " + this.state.partials.overall.S3.lap}</span>
                            <span style={{fontSize: 22}}>{Moment(this.state.partials.overall.S3.stamp).tz(this.state.circuitTimezone).format("HH:mm:ss")}</span>
                        </ReactTooltip>
                    </div>
                </td>
                <td className={"hidden-xs"}
                    colSpan={(this.state.privileges.includes(super_admin) || this.state.privileges.includes(admin) || this.state.privileges.includes(sub_admin)) ? 7 : 6}
                    rowSpan={2}
                    style={{fontWeight: "bold", borderLeft: "2px solid white", borderRight: "2px solid white"}}
                >
                    <button
                        type={"button"}
                        className={"btn btn-primary btn-block button toHide App_bold_white_text"}
                        onClick={this.handleOpenModalCSV}
                    >
                        {this.props.t("export")} CSV <i className={"fas fa-file-download"}/>
                    </button>
                    {!this.state.isMobile ? (
                        <button
                            type={"button"}
                            className={"btn btn-primary btn-block button toHide App_bold_white_text"}
                            onClick={this.makeEXCEL}
                        >
                            {this.props.t("export")} EXCEL <i className={"fas fa-file-download"}/>
                        </button>
                    ) : (
                        <div/>
                    )}
                </td>
            </tr>
        );

        let containerPersonal = (
            <tr className={"App_white_text"}>
                <td style={{fontSize: 17, background: this.state.personalBestColor}} colSpan={2}>
                    {this.props.t("personalBestSectors")}
                </td>
                <td>
                    <b>{formatTime(this.state.partials.single.S1.time + this.state.partials.single.S2.time + this.state.partials.single.S3.time)}</b>
                </td>
                <td className={"hidden-xs"}
                    colSpan={3}
                    style={{fontWeight: "bold", borderLeft: "2px solid white", borderRight: "2px solid white"}}
                    data-tip={true}
                    data-for={"S1_single"}
                >
                    <div style={{cursor: "pointer"}}>
                        {this.state.partials.single.S1.time > 0 ?
                            (((this.state.partials.single.S1.time / 1000) * 1000) / 1000).toFixed(3) : "---"
                        }
                        <ReactTooltip id={"S1_single"} type={"light"}>
                            <span className={"App_title"}>{this.state.partials.single.S1.driver.toUpperCase()}</span>
                            <span style={{fontSize: 22}}>#{this.state.partials.single.S1.number} {this.state.partials.single.S1.team}</span>
                            <span className={"App_title"}>{this.props.t("lap") + " " + this.state.partials.single.S1.lap}</span>
                            <span style={{fontSize: 22}}>{Moment(this.state.partials.single.S1.stamp).tz(this.state.circuitTimezone).format("HH:mm:ss")}</span>
                        </ReactTooltip>
                    </div>
                </td>
                <td className={"hidden-xs"}
                    colSpan={3}
                    style={{fontWeight: "bold", borderLeft: "2px solid white", borderRight: "2px solid white"}}
                    data-tip={true}
                    data-for={"S2_single"}
                >
                    <div style={{cursor: "pointer"}}>
                        {this.state.partials.single.S2.time > 0 ?
                            (((this.state.partials.single.S2.time / 1000) * 1000) / 1000).toFixed(3) : "---"
                        }
                        <ReactTooltip id={"S2_single"} type={"light"}>
                            <span className={"App_title"}>{this.state.partials.single.S2.driver.toUpperCase()}</span>
                            <span style={{fontSize: 22}}>#{this.state.partials.single.S2.number} {this.state.partials.single.S2.team}</span>
                            <span className={"App_title"}>{this.props.t("lap") + " " + this.state.partials.single.S2.lap}</span>
                            <span style={{fontSize: 22}}>{Moment(this.state.partials.single.S2.stamp).tz(this.state.circuitTimezone).format("HH:mm:ss")}</span>
                        </ReactTooltip>
                    </div>
                </td>
                <td className={"hidden-xs"}
                    colSpan={4}
                    style={{fontWeight: "bold", borderLeft: "2px solid white", borderRight: "2px solid white"}}
                    data-tip={true}
                    data-for={"S3_single"}
                >
                    <div style={{cursor: "pointer"}}>
                        {this.state.partials.single.S3.time > 0 ?
                            (((this.state.partials.single.S3.time / 1000) * 1000) / 1000).toFixed(3) : "---"
                        }
                        <ReactTooltip id={"S3_single"} type={"light"}>
                            <span className={"App_title"}>{this.state.partials.single.S3.driver.toUpperCase()}</span>
                            <span style={{fontSize: 22}}>#{this.state.partials.single.S3.number} {this.state.partials.single.S3.team}</span>
                            <span className={"App_title"}>{this.props.t("lap") + " " + this.state.partials.single.S3.lap}</span>
                            <span style={{fontSize: 22}}>{Moment(this.state.partials.single.S3.stamp).tz(this.state.circuitTimezone).format("HH:mm:ss")}</span>
                        </ReactTooltip>
                    </div>
                </td>
            </tr>
        );

        this.setState({
            overallTheoreticalBestLap: containerOverall,
            personalTheoreticalBestLap: containerPersonal
        }, () => {
            callback("done");
        });
    }

    makePersonalTheoreticalBestLapRow(callback) {
        let theoreticalBest = 0;
        let bestPartials = [];
        for (let i = 0; i < this.state.sectors.length; i++) {
            let tempMin = Number.POSITIVE_INFINITY;
            for (let j = 0; j < this.state.laps.length; j++) {
                for (let k = 0; k < this.state.laps[j].splits.length; k++) {
                    if (this.state.laps[j].splits[k].order_no === this.state.sectors[i].order_no) {
                        if (
                            this.state.laps[j].splits[k].time < tempMin &&
                            this.state.laps[j].splits[k].time > 0 &&
                            /*this.state.laps[j].registry_timestamp >= (this.state.startTimestamp * 1000) &&*/
                            (this.state.lastReset === null ? true : this.state.laps[j].registry_timestamp >= this.state.lastReset)
                        ) {
                            tempMin = this.state.laps[j].splits[k].time;
                            break;
                        }
                    }
                }
            }

            if (tempMin === Number.POSITIVE_INFINITY) {
                bestPartials[i] = {order_no: this.state.sectors[i].order_no, time: 0};
            } else {
                bestPartials[i] = {order_no: this.state.sectors[i].order_no, time: tempMin};
                theoreticalBest += tempMin;
            }
        }

        let counter = 0;
        const best = (
            <tr key={"BEST"} className={"App_white_text hidden-xs"}>
                <td style={{fontSize: 17, background: this.state.personalBestColor}} colSpan={3}>
                    {this.props.t("personalBestPartials")}
                </td>
                {bestPartials.map((sector, index) => {
                    let style = {};
                    if (index === 2 || index === 5) {
                        style = {borderRight: "2px solid white"};
                    }
                    return (
                        <td key={counter++}
                            className={"hidden-xs"}
                            style={style}
                        >
                            {sector.time > 0 ? (((sector.time / 1000) * 1000) / 1000).toFixed(3) : "---"}
                        </td>
                    );
                })}
                <td className={"hidden-xs"} style={{borderLeft: "2px solid white"}}>
                    {(this.state.maxes.personal.max_rpm ? this.state.maxes.personal.max_rpm : "---")}
                </td>
                <td className={"hidden-xs"} style={{borderRight: "2px solid white"}}>
                    {(this.state.maxes.personal.max_throttled_rpm ? this.state.maxes.personal.max_throttled_rpm : "---")}
                </td>
                <td colSpan={(this.state.privileges.includes(super_admin) || this.state.privileges.includes(admin) || this.state.privileges.includes(sub_admin)) ? 3 : 2} className={"hidden-xs"}>
                    {(this.state.maxes.personal.max_speed ? this.state.maxes.personal.max_speed : "---")} / {!isFinite(calculateAVGSpeed(theoreticalBest, this.state.circuitLength)) ? "---" : calculateAVGSpeed(theoreticalBest, this.state.circuitLength)}
                </td>
            </tr>
        );

        this.setState({
            personalTheoreticalBestPartialsRow: best,
            personalTheoreticalBestPartialsData: bestPartials,
        }, () => {
            callback("done");
        });
    }

    makeOverallTheoreticalBestPartialsRow(callback) {
        const helper = this;
        $.ajax({
                type: 'POST',
                url: serverIP + ':' + backendPort + '/dashboard/getOverallMinSplits',
                dataType: 'json',
                headers: {
                    'authorization': helper.props.cookies.get("authToken")
                },
                data: {
                    sessionID: helper.state.sessionID,
                },
                success: function (bestPartials) {
                    let theoreticalBest = 0;
                    let splits = [];

                    for (let i = 0; i < helper.state.sectors.length; i++) {
                        if (bestPartials[i] !== undefined) {
                            theoreticalBest += bestPartials[i].time;
                        }

                        let found = false;
                        for (let j = 0; j < bestPartials.length; j++) {

                            if (bestPartials[j] !== undefined && helper.state.sectors[i].order_no === bestPartials[j].order_no) {
                                let style = {};
                                if (bestPartials[j].order_no === 2 || bestPartials[j].order_no === 5) {
                                    style = {borderRight: "2px solid white"};
                                }
                                splits.push(
                                    <td key={bestPartials[j].order_no}
                                        className={"hidden-xs"}
                                        style={style}
                                        data-tip={true}
                                        data-for={"sector_" + bestPartials[j].order_no}
                                    >
                                        <div style={{cursor: "pointer"}}>
                                            {bestPartials[j].time > 0 ? (((bestPartials[j].time / 1000) * 1000) / 1000).toFixed(3) : "---"}
                                            <ReactTooltip id={"sector_" + bestPartials[j].order_no} type={"light"}>
                                                <span className={"App_title"}>{bestPartials[j].name.toUpperCase()}</span>
                                                <span style={{fontSize: 22}}><b>#{bestPartials[j].livery_number} {bestPartials[j].short_name}</b></span>
                                                <span className={"App_title"}>{helper.props.t("lap") + " " + bestPartials[j].lap_number}</span>
                                                <span style={{fontSize: 22}}><b>{Moment(bestPartials[j].registry_timestamp).tz(helper.state.circuitTimezone).format("HH:mm:ss")}</b></span>
                                            </ReactTooltip>
                                        </div>
                                    </td>
                                );
                                found = true;
                            }
                        }
                        if (!found) {
                            splits.push(
                                <td key={helper.state.sectors[i].order_no}
                                    className={"hidden-xs"}
                                >
                                    <div style={{cursor: "pointer"}}>---</div>
                                </td>
                            );
                        }
                    }

                    const best = (
                        <tr key={"OVERALL"} className={"hidden-xs App_white_text"}>
                            <td style={{fontSize: 17, background: helper.state.overallBestColor}} colSpan={3}>
                                {helper.props.t("overallBestPartials")}
                            </td>
                            {splits}
                            <td className={"hidden-xs"} style={{borderLeft: "2px solid white"}}>
                                {(helper.state.maxes.overall.max_rpm ? helper.state.maxes.overall.max_rpm : "---")}
                            </td>
                            <td className={"hidden-xs"} style={{borderRight: "2px solid white"}}>
                                {(helper.state.maxes.overall.max_throttled_rpm ? helper.state.maxes.overall.max_throttled_rpm : "---")}
                            </td>
                            <td colSpan={(helper.state.privileges.includes(super_admin) || helper.state.privileges.includes(admin) || helper.state.privileges.includes(sub_admin)) ? 3 : 2} className={"hidden-xs"}>
                                {(helper.state.maxes.overall.max_speed ? helper.state.maxes.overall.max_speed : "---")} / {!isFinite(calculateAVGSpeed(theoreticalBest, helper.state.circuitLength)) ? "---" : calculateAVGSpeed(theoreticalBest, helper.state.circuitLength)}
                            </td>
                        </tr>
                    );

                    helper.setState({
                        overallTheoreticalBestRow: best,
                        overallTheoreticalBestData: bestPartials,
                    }, () => {
                        callback("done");
                    });
                },
                error: function (err) {
                    if (err) {
                        console.error('Error:', err);
                    }
                    callback("not done");
                }
            }
        );
    }

    makeSplits(lap) {

        let splits = [];

        if (this.state.sectorView) {

            // Make headers
            const headers = [
                <th colSpan={3} key={"S1_h"} className={"App_header_background hidden-xs"}>S1</th>,
                <th colSpan={3} key={"S2_h"} className={"App_header_background hidden-xs"}>S2</th>,
                <th colSpan={4} key={"S3_h"} className={"App_header_background hidden-xs"}>S3</th>,
            ];

            this.setState({
                splitHeaders: headers,
            });

            let background_S1 = {backgroundColor: "rgba(80,80,80,0.4)", borderRight: "2px solid white",};
            if (this.state.partials.single.S1.time === lap.S1) {
                // Check if his personal best is also overall best
                if (this.state.partials.overall.S1.time === lap.S1) {
                    background_S1.backgroundColor = this.state.overallBestColor;
                } else {
                    background_S1.backgroundColor = this.state.personalBestColor;
                }
            }

            let background_S2 = {backgroundColor: "rgba(80,80,80,0.4)", borderRight: "2px solid white",};
            if (this.state.partials.single.S2.time === lap.S2) {
                // Check if his personal best is also overall best
                if (this.state.partials.overall.S2.time === lap.S2) {
                    background_S2.backgroundColor = this.state.overallBestColor;
                } else {
                    background_S2.backgroundColor = this.state.personalBestColor;
                }
            }

            let background_S3 = {backgroundColor: "rgba(80,80,80,0.4)", borderRight: "2px solid white",};
            if (this.state.partials.single.S3.time === lap.S3) {
                // Check if his personal best is also overall best
                if (this.state.partials.overall.S3.time === lap.S3) {
                    background_S3.backgroundColor = this.state.overallBestColor;
                } else {
                    background_S3.backgroundColor = this.state.personalBestColor;
                }
            }

            splits.push(
                <td colSpan={3} className={"hidden-xs"} key={"S1"} id={"split_cell"} style={lap.S1 > 0 ? background_S1 : {borderRight: "2px solid white",}}>
                    {lap.S1 > 0 ? (((lap.S1 / 1000) * 1000) / 1000).toFixed(3) : "---"}
                </td>
            );
            splits.push(
                <td colSpan={3} className={"hidden-xs"} key={"S2"} id={"split_cell"} style={lap.S2 > 0 ? background_S2 : {borderRight: "2px solid white",}}>
                    {lap.S2 > 0 ? (((lap.S2 / 1000) * 1000) / 1000).toFixed(3) : "---"}
                </td>
            );
            splits.push(
                <td colSpan={4} className={"hidden-xs"} key={"S3"} id={"split_cell"} style={lap.S3 > 0 ? background_S3 : {borderRight: "2px solid white",}}>
                    {lap.S3 > 0 ? (((lap.S3 / 1000) * 1000) / 1000).toFixed(3) : "---"}
                </td>
            );

        } else {

            let headers = [];
            // Iterate through known sectors
            for (let i = 0; i < this.state.sectors.length; i++) {

                headers.push(<th key={"p" + this.state.sectors[i].order_no} className={"App_header_background hidden-xs"}>P {parseInt(this.state.sectors[i].order_no) + 1}</th>);

                let sectorBackground = {backgroundColor: "rgba(80,80,80,0.4)", borderRight: [2, 5].includes(this.state.sectors[i].order_no) ? "2px solid white" : ""};
                let cell = null;

                if (lap.splits.length > 0) {
                    // For each sector time recorded by the car
                    for (let j = 0; j < lap.splits.length; j++) {
                        // Check if we're comparing the same sectors (avoid errors when devices miss sectors)
                        // Also check if split time isn't bigger than the whole lap
                        if (lap.splits[j].order_no === this.state.sectors[i].order_no && lap.splits[j].time < lap.time) {
                            sectorBackground.borderRight = (lap.splits[j].order_no === 2 || lap.splits[j].order_no === 5 ? "2px solid white" : "");
                            // Check if said sector was his personal best
                            for (let k = 0; k < this.state.personalTheoreticalBestPartialsData.length; k++) {
                                if (this.state.personalTheoreticalBestPartialsData[k].order_no === lap.splits[j].order_no && this.state.personalTheoreticalBestPartialsData[k].time === lap.splits[j].time) {
                                    // Check if his personal best is also overall best
                                    if (
                                        this.state.personalTheoreticalBestPartialsData[k] &&
                                        this.state.overallTheoreticalBestData[k] &&
                                        this.state.personalTheoreticalBestPartialsData[k].order_no === this.state.overallTheoreticalBestData[k].order_no &&
                                        this.state.personalTheoreticalBestPartialsData[k].time === this.state.overallTheoreticalBestData[k].time
                                    ) {
                                        sectorBackground.backgroundColor = this.state.overallBestColor;
                                        break;
                                    } else {
                                        sectorBackground.backgroundColor = this.state.personalBestColor;
                                        break;
                                    }
                                }
                            }
                            cell = (<td className={"hidden-xs"} key={i + "_" + j} id={"split_cell"} style={lap.splits[j].time ? sectorBackground : {}}>{lap.splits[j].time ? (((lap.splits[j].time / 1000) * 1000) / 1000).toFixed(3) : "---"}</td>);
                            break;
                        } else {
                            let blankPartial = {
                                borderRight: (this.state.sectors[i].order_no === 2 || this.state.sectors[i].order_no === 5 ? "2px solid white" : ""),
                                backgroundColor: "rgb(0,0,0,0)",
                            };
                            cell = (<td className={"hidden-xs"} key={i + "_" + j} id={"split_cell"} style={blankPartial}>---</td>);
                        }
                    }
                    splits.push(cell);
                } else {
                    for (i = 0; i < this.state.sectors.length; i++) {
                        cell = (<td className={"hidden-xs"} key={i} id={"split_cell"}>---</td>);
                        splits.push(cell);
                    }
                }
            }
            this.setState({
                splitHeaders: headers,
            });
        }

        return splits;
    }

    makeTableRows(callback) {
        let rows = [];
        if (this.state.laps.length > 0) {

            // Get sub-set of laps to render based on pageSize property (this.state)
            let lapsToShow = this.state.laps.slice(this.state.firstRecord, this.state.firstRecord + this.state.pageSize);

            // Evaluate paging buttons initial state
            if (this.state.laps.length > this.state.pageSize) {
                $('#next').prop("disabled", false);
            }

            if (this.state.laps[(this.state.laps.length - 1)].id === lapsToShow[(lapsToShow.length - 1)].id) {
                $('#next').prop("disabled", true);
            } else {
                $('#next').prop("disabled", false);
            }

            for (let i = 0; i < lapsToShow.length; i++) {
                let lap = lapsToShow[i];
                // For each lap the car made
                // Render SPLITs according to user preference
                let splits = this.makeSplits(lap);

                // Check if best lap
                let lapStyle = {borderRight: "2px solid white", margin: 0, padding: 0};
                let driverStyle = {borderRight: "2px solid white", margin: 0, padding: 0};

                if (lap.time === this.state.maxes.personal.min_time) {
                    if (lap.time === this.state.maxes.overall.min_time) {
                        lapStyle.backgroundColor = this.state.overallBestColor;
                    } else {
                        lapStyle.backgroundColor = this.state.personalBestColor;
                    }
                }

                // Check if max rpm
                let rpmColor = "";
                if (lap.max_rpm === this.state.maxes.personal.max_rpm) {
                    if (lap.max_rpm === this.state.maxes.overall.max_rpm) {
                        rpmColor = this.state.overallBestColor;
                    } else {
                        rpmColor = this.state.personalBestColor;
                    }
                }

                // Check if max throttled rpm
                let throttledRpmColor = "";
                if (lap.max_throttled_rpm === this.state.maxes.personal.max_throttled_rpm) {
                    if (lap.max_throttled_rpm === this.state.maxes.overall.max_throttled_rpm) {
                        throttledRpmColor = this.state.overallBestColor;
                    } else {
                        throttledRpmColor = this.state.personalBestColor;
                    }
                }

                // Check if max speed
                let speedColor = "";
                if (lap.max_speed === this.state.maxes.personal.max_speed) {
                    if (lap.max_speed === this.state.maxes.overall.max_speed) {
                        speedColor = this.state.overallBestColor;
                    } else {
                        speedColor = this.state.personalBestColor;
                    }
                }

                rows.push(
                    <tr
                        key={lap.id}
                        className={"onHover App_white_text " + (lap.is_valid === 0 ? "App_invalidRow" : "")}
                        onClick={(event) => this.handleSelectLap(event, lap.uuid, lap.has_bulk)}
                    >
                        <td style={{width: "2%"}}>
                            <button
                                data-tip={true}
                                data-for={"hasBulk_" + lap.id}
                                style={{background: "#ff0003", fontWeight: "bold"}}
                                type={"button"}
                                className={"btn button"}
                                value={lap.uuid}
                                onClick={this.popoutDetail}
                            >
                                <span className={"App_small_title App_white_text"}>{lap.lap_number}</span>
                                {(lap.conn_type === '4G') && (this.state.isOwnTeam === 1 || this.state.privileges.includes(super_admin)) ? (
                                    lap.has_bulk === 1 ? (
                                        <>
                                            <i className={"fas fa-check-circle"} style={{marginLeft: 6, pointerEvents: "none"}}/>
                                            <ReactTooltip id={"hasBulk_" + lap.id} type={"light"} place={"right"}>
                                                <span className={"App_title"}>{this.props.t("hasBulkData")}</span>
                                            </ReactTooltip>
                                        </>
                                    ) : (
                                        <>
                                            <i className={"far fa-times-circle"} style={{marginLeft: 6, pointerEvents: "none"}}/>
                                            <ReactTooltip id={"hasBulk_" + lap.id} type={"light"} place={"right"}>
                                                <span className={"App_title"}>{this.props.t("noBulkData")}</span>
                                            </ReactTooltip>
                                        </>
                                    )
                                ) : null}
                            </button>
                        </td>
                        <td style={driverStyle}>
                            <span style={{display: "block"}}>{lap.driver_name.toUpperCase()}</span>
                            <span className={"App_timestampStyle"}>
                                    {Moment(lap.registry_timestamp).tz(this.state.circuitTimezone).format("DD/MM/YYYY | HH:mm:ss")}
                                </span>
                        </td>
                        <td style={lapStyle}>
                            <span style={{display: "block"}}>{formatTime(lap.time)}</span>
                            <span className={"App_lapGapStyle"} style={{color: lap.split_to_previous_lap_time < 0 ? "#00ff38" : "#ff1b00"}}>
                                    {(lap.split_to_previous_lap_time > 0 ? "+" : "") + (lap.split_to_previous_lap_time / 1000)}
                                </span>
                        </td>
                        {splits}
                        <td className={"hidden-xs"} style={{borderLeft: "2px solid white", backgroundColor: rpmColor}}>{lap.max_rpm && lap.max_throttled_rpm < 65535 ? lap.max_rpm : "---"}</td>
                        <td className={"hidden-xs"} style={{backgroundColor: throttledRpmColor, borderRight: "1px solid white"}}>{lap.max_throttled_rpm && lap.max_throttled_rpm < 65535 ? lap.max_throttled_rpm : "---"}</td>
                        <td className={"hidden-xs"} style={{backgroundColor: speedColor}}>{(lap.max_speed > 0 && lap.max_speed < 500) ? lap.max_speed : "---"} / {calculateAVGSpeed(lap.time, this.state.circuitLength)}</td>
                        <td style={{width: "1%"}}>
                            <label className={"control control-checkbox text-center toHide"}>
                                <input
                                    id={lap.uuid}
                                    type={"checkbox"}
                                    onClick={(event) => this.handleSelectLap(event, lap.uuid)}
                                />
                                <div className={"control_indicator"}/>
                            </label>
                        </td>
                        {(this.state.privileges.includes(super_admin) || this.state.privileges.includes(admin) || this.state.privileges.includes(sub_admin)) ? (
                            <td style={{width: "2%"}}>
                                {lap.is_valid === 0 ? (
                                    <button
                                        style={{background: "#cf000f", fontWeight: "bold"}}
                                        type={"button"}
                                        className={"btn btn-block button"}
                                        value={lap.uuid + "_" + lap.is_valid}
                                        onClick={this.handleShowModal}
                                    >
                                        <i className={"fas fa-times toHide"} style={{color: "#ffffff"}}/>
                                    </button>
                                ) : (
                                    <button
                                        style={{background: "#00921a", fontWeight: "bold"}}
                                        type={"button"}
                                        className={"btn btn-block button"}
                                        value={lap.uuid + "_" + lap.is_valid}
                                        onClick={this.handleShowModal}
                                    >
                                        <i className="fas fa-check toHide" style={{color: "#ffffff", pointerEvents: "none"}}/>
                                    </button>
                                )}
                            </td>
                        ) : (
                            <td className={"hidden-xs hidden-lg"}/>
                        )}
                    </tr>
                );
            }
        }

        this.setState({
            tableRows: rows,
        }, () => {
            if (callback) {
                callback("done");
            }
        });
    }

    makeCSVmodalRows() {
        let indexes = [];
        let subset = [];
        let rows = [];

        for (let i = 0; i < this.state.laps.length; i++) {
            if (this.state.laps[i].uuid === this.state.selectedLaps[0] || this.state.laps[i].uuid === this.state.selectedLaps[1]) {
                indexes.push(i);
                if (indexes.length === this.state.selectedLaps.length) {
                    if (indexes.length === 1) {
                        subset.push(this.state.laps[i]);
                    } else {
                        subset = this.state.laps.slice(indexes[0], indexes[1] + 1);
                    }
                    break;
                }
            }
        }

        for (let i = (subset.length - 1); i >= 0; i--) {
            rows.push(
                <tr key={"csv_" + i}>
                    <td>{Moment(subset[i].registry_timestamp).tz(this.state.circuitTimezone).format("DD/MM/YYYY | HH:mm:ss")}</td>
                    <td>{subset[i].lap_number}</td>
                    <td>{subset[i].driver_name}</td>
                    <td>{formatTime(subset[i].time)}</td>
                </tr>
            );
        }

        this.setState({
            CSVmodalRows: rows,
            CSVmodalIndexes: indexes,
        });
    }

    render() {
        return (
            <>
                <div className="loading">
                    <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                </div>
                <Alert stack={{limit: 10}} html={true}/>
                {this.props.match ? (<PortraitModal/>) : null}
                <div className={"container-fluid"} style={{marginTop: 15, marginBottom: 15}}>
                    <div className={"row"}>
                        <div id={"sectorTable"} className={"App_ContainerStyle table-scroll-parent"} style={{whiteSpace: "nowrap", height: "auto"}}>
                            <div className={"table-scroll-child table-responsive"}>
                                <table id={"lapTimesTest"} className={"table table-condensed borderTest"} style={{textAlign: "center", marginBottom: "0"}}>
                                    <thead>
                                    {this.state.overallTheoreticalBestLap}
                                    {this.state.personalTheoreticalBestLap}
                                    <tr>
                                        <td className={"hidden-xs"} colSpan={(this.state.privileges.includes(super_admin) || this.state.privileges.includes(admin) || this.state.privileges.includes(sub_admin)) ? 20 : 19} style={{background: "#eb1f24"}}/>
                                    </tr>
                                    {this.state.overallTheoreticalBestRow}
                                    {this.state.personalTheoreticalBestPartialsRow}
                                    <tr>
                                        <td className={"hidden-xs"} colSpan={(this.state.privileges.includes(super_admin) || this.state.privileges.includes(admin) || this.state.privileges.includes(sub_admin)) ? 20 : 19} style={{background: "#eb1f24"}}/>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                        <div className={"col-xs-12 row-flex text-center"} style={{margin: 10}}>
                            <div className={"col-xs-12 col-md-4 text-left"}>
                                <button
                                    className={"btn App_white_text button"}
                                    style={{background: "#ff0003", fontWeight: "bold", marginRight: 3}}
                                    id={"start"}
                                    onClick={this.handleClickPager}
                                >
                                    <i className={"fas fa-angle-double-left"}/>
                                </button>
                                <button className={"paginate btn App_white_text button"}
                                        style={{background: "#ff0003", fontWeight: "bold", marginRight: 3}}
                                        onClick={this.handleClickPager}
                                        id={"previous"}
                                >
                                    {this.props.t("previous")}
                                </button>
                                <button className={"paginate btn App_white_text button"}
                                        style={{background: "#ff0003", fontWeight: "bold", marginRight: 3}}
                                        onClick={this.handleClickPager}
                                        id={"next"}
                                >
                                    {this.props.t("next")}
                                </button>
                                <button
                                    className={"btn App_white_text button"}
                                    style={{background: "#ff0003", fontWeight: "bold"}}
                                    id={"end"}
                                    onClick={this.handleClickPager}
                                >
                                    <i className={"fas fa-angle-double-right"}/>
                                </button>
                            </div>
                            <div className={"col-xs-12 col-md-2 text-center"}>
                                <img alt="" src={logo} style={{maxHeight: 50}}/>
                            </div>
                            <div className={"col-xs-12 col-md-offset-2 col-md-4 toHide row-flex hidden-xs"}>
                                <div className={"col-xs-6 col-md-5"}>
                                    <Toggle
                                        onClick={this.onToggleSectorView}
                                        on={<h5 className={"App_bold_white_text"}>{this.props.t("sectors").toUpperCase()}</h5>}
                                        off={<h5 className={"App_bold_white_text"}>{this.props.t("partials").toUpperCase()}</h5>}
                                        width={"100%"}
                                        onstyle={"danger"}
                                        offstyle={"danger"}
                                        handlestyle={"success"}
                                        style={{borderRadius: 10}}
                                        active={this.state.sectorView}
                                        disabled={!this.state.sectorViewActive}
                                    />
                                </div>
                                <div className={"col-xs-6 col-md-7 hidden-xs"}>
                                    <button
                                        type="button"
                                        className={"btn btn-primary btn-block button App_bold_white_text"}
                                        style={{
                                            height: "100%",
                                            marginTop: 0,
                                            whiteSpace: "normal"
                                        }}
                                        onClick={this.popoutComparison}
                                    >{this.props.t("compareLaps")} <i className="fas fa-search"/>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div id={"mainTable"} className={"App_ContainerStyle table-scroll-parent"} style={{whiteSpace: "nowrap", height: "80vh"}}>
                            <div className={"table-scroll-child table-responsive"}>
                                <table id={"lapTimesTable"} className={"table table-condensed borderTest"} style={{textAlign: "center"}}>
                                    <thead>
                                    <tr>
                                        <th className={"App_header"}>{this.props.t("lap").toUpperCase()}</th>
                                        <th className={"App_header"}>{this.props.t("driver").toUpperCase()}</th>
                                        <th className={"App_header"}>{this.props.t("lapTime").toUpperCase()}</th>
                                        {this.state.splitHeaders}
                                        <th className={"App_header hidden-xs"}>{this.props.t("rpm").toUpperCase()}</th>
                                        <th className={"App_header hidden-xs"}>{this.props.t("rpmThr").toUpperCase()}</th>
                                        <th className={"App_header hidden-xs"}>{this.props.t("maxAvgSpd").toUpperCase()}</th>
                                        <th/>
                                        <th className={"hidden-xs " + ((this.state.privileges.includes(super_admin) || this.state.privileges.includes(admin) || this.state.privileges.includes(sub_admin)) ? "" : "hidden-lg")}/>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.tableRows}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <Modal open={this.state.show}
                           onClose={this.handleCloseModal}
                           center={false}
                           classNames={{modal: "small-modal"}}
                           showCloseIcon={false}
                    >
                        <div className={"modal-header"}>
                            <div className={"modal-title"}>
                                <b className={"App_header"} style={{color: "#000000"}}>{this.props.t("changeLapState")}?</b>
                            </div>
                        </div>
                        <div className={"modal-body"}>
                            <p className={"App_smallHeader"} style={{color: "#000000"}}>{this.props.t("changeLapStateText_1")} <b>{this.state.lapState}</b>.<br/> {this.props.t("changeLapStateText_2")}.</p>
                            {this.state.waiting ? (
                                <div className={"alert alert-warning"} role={"alert"}>
                                    {this.props.t("waitingForServer")}...
                                </div>
                            ) : (
                                <div/>
                            )}
                            {this.state.serverResult}
                        </div>
                        <div className={"modal-footer"}>
                            <button
                                className={"btn App_header button"}
                                style={{background: "#ff0003", color: "#FFFFFF"}}
                                onClick={this.handleConfirmAction}
                            >{this.props.t("yes")}
                            </button>
                            <button
                                onClick={this.handleCloseModal}
                                className={"btn App_header button"}
                                style={{background: "#ff0003", color: "#FFFFFF"}}
                            >{this.props.t("no")}
                            </button>
                        </div>
                    </Modal>
                    <Modal open={this.state.csvModalShow}
                           onClose={this.handleCloseModalCSV}
                           center={false}
                           classNames={{modal: "medium-modal"}}
                           showCloseIcon={false}
                    >
                        <div className={"modal-header"}>
                            <div className={"modal-title"}>
                                <b className={"App_header"} style={{color: "#000000"}}>{this.props.t("downloadCSV")}</b>
                            </div>
                        </div>
                        <div className={"modal-body"}>
                            <div className={"App_ContainerStyle table-scroll-parent"} style={{whiteSpace: "nowrap", height: "45vh", overflowY: "auto"}}>
                                <div className={"table-scroll-child table-responsive"}>
                                    <table className={"table table-condensed borderTest App_black_text"} style={{textAlign: "center"}}>
                                        <thead>
                                        <tr className={"text-center"}>
                                            <th className={"App_smallHeader"} style={{color: "#000000"}}>{this.props.t("completedAt")}</th>
                                            <th className={"App_smallHeader"} style={{color: "#000000"}}>{this.props.t("lap")} {this.props.t("nr")}</th>
                                            <th className={"App_smallHeader"} style={{color: "#000000"}}>{this.props.t("driver")}</th>
                                            <th className={"App_smallHeader"} style={{color: "#000000"}}>{this.props.t("time")}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.CSVmodalRows}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            <button
                                id={"btnGenerateCSV"}
                                className={"btn App_header button"}
                                style={{background: "#ff0003", color: "#FFFFFF"}}
                                onClick={this.handleCGenerateCSV}
                            >{this.props.t("confirmRequest")}
                            </button>
                            <button
                                onClick={this.handleCloseModalCSV}
                                className={"btn App_header button"}
                                style={{background: "#ff0003", color: "#FFFFFF"}}
                            >{this.props.t("close")}
                            </button>
                        </div>
                    </Modal>
                </div>
            </>
        );
    }
}

export default withTranslation("translations")(withCookies(PopoutLapTimes));